export default "/assets/images/CC-product-with-box.cc624c55a5d6d0eb.png";